import PropTypes from 'prop-types';
import { Form, DatePicker } from 'antd';
import EbzProductsFilter from 'components/EbzProductsFilter/EbzProductsFilter';
import EbzTreeSelect from 'components/EbzTreeSelect';

function DashBoardFilterPage({
  formName,
  productList,
  merchants,
  dashBoardForm,
  RANGE_PRESETS_DAYS,
  disabledDate,
  fetchMerchantList,
  merchantLoading,
  setMerchantPagination,
  merchantTransactionListRef,
  selectedMerchantTotalCounts
}) {
  const { RangePicker } = DatePicker;

  return (
    <Form layout="vertical" form={dashBoardForm} name={formName} className="dashboard-form">
      <Form.Item
        className="dashboard-products-date-filter"
        name="dashboardRangePicker"
        label="Date"
        rules={[
          {
            required: true,
            message: 'Please select valid date'
          },
          {
            validator(_, value) {
              if (
                value &&
                value[0] !== null &&
                value[1] !== null &&
                value[1].diff(value[0], 'days') >= 31
              ) {
                // eslint-disable-next-line prefer-promise-reject-errors
                return Promise.reject('Please Select Max Up to One Month');
              }
              return Promise.resolve();
            }
          }
        ]}
      >
        <RangePicker
          activeBg="#1677ff"
          activeShadow="1 1 1 2px rgba(20, 145, 255, 0.1)"
          style={{ borderRadius: '3px', width: '100%' }}
          presets={RANGE_PRESETS_DAYS}
          disabledDate={disabledDate}
        />
      </Form.Item>

      <Form.Item
        label="Choose Merchants"
        className="dashboard-products-merchant-filter"
        name="dashboardMerchantId"
      >
        <EbzTreeSelect
          merchants={merchants}
          fetchMerchantList={fetchMerchantList}
          merchantLoading={merchantLoading}
          setMerchantPagination={setMerchantPagination}
          formName={formName}
          merchantTransactionListRef={merchantTransactionListRef}
          selectedMerchantTotalCounts={selectedMerchantTotalCounts}
        />
      </Form.Item>

      <Form.Item
        className="dashboard-products-product-list-filter"
        label="Choose Products"
        name="dashboardProducts"
      >
        <EbzProductsFilter data={productList} />
      </Form.Item>
    </Form>
  );
}

DashBoardFilterPage.propTypes = {
  formName: PropTypes.string.isRequired,
  productList: PropTypes.instanceOf(Array).isRequired,
  merchants: PropTypes.instanceOf(Array).isRequired,
  dashBoardForm: PropTypes.instanceOf(Object).isRequired,
  RANGE_PRESETS_DAYS: PropTypes.instanceOf(Array).isRequired,
  disabledDate: PropTypes.func.isRequired,
  fetchMerchantList: PropTypes.func.isRequired,
  merchantLoading: PropTypes.bool.isRequired,
  setMerchantPagination: PropTypes.func.isRequired,
  merchantTransactionListRef: PropTypes.instanceOf(Object).isRequired,
  selectedMerchantTotalCounts: PropTypes.number.isRequired
};

export default DashBoardFilterPage;
